<template>
  <require from="framework/html_behaviors/af-mutex-click"></require>
  <require from="controls/bs-form-input"></require>
  <require from="controls/bs-form-select"></require>
  <require from="controls/as-page-jumbo.html"></require>
  <require from="controls/as-form-skeleton"></require>
  <require from="controls/as-form-widget.html"></require>
  <require from="components/question-panel"></require>

  <div class="admin-questions-screen">
    <as-page-jumbo icon="fas fa-question-circle fa-fw" heading="Questions administration" intro="Manage questions and their countries.">
      <div slot="default">
        <as-form-widget>
          <div slot="default">
            <div class="form-row">
              <div class="col-md-12 col-lg-6">
                <bs-form-input type="text" label="Question or Country" placeholder="Type to search" value.bind="filterText & debounce"></bs-form-input>
              </div>
              <div class="col-md-12 col-lg-6">
                <bs-form-select label="Archive" value.bind="includeArchived" options.bind="archiveOptions" value-path="value" name-path="name"></bs-form-select>
              </div>
            </div>
          </div>
        </as-form-widget>
        <div class="sc-buttons-container">
          <button type="button" class="btn btn-light" af-mutex-click.call="createNewQuestion()">
            <i class="fas fa-plus"></i> Create new
          </button>
        </div>
      </div>
    </as-page-jumbo>
    <form class="container-fluid">
      <div if.bind="loaded">
        <question-panel repeat.for="question of questions" question-detail-model.bind="question" filter-text.bind="filterText" cancel-new.call="cancelCreateNewQuestion()" show.bind="question.isVisible"></question-panel>
      </div>
      <as-form-skeleton else></as-form-skeleton>
    </form>
  </div>
</template>
